import CustomFilterSelect from "./CustomFilterSelect";

const FilterDateLastYear = (props: any) => {
  const { source, label, variant } = props;
  //last one year
  const DateFilterData = [
    { id: "current", name: "Current Year" },
    { id: "last1", name: "Last Year" },
    { id: "last2_3", name: "Last 2-3 Years" },
    { id: "last3_5", name: "Last 3-5 Years" },
    { id: "last5", name: "> 5 Years Ago" },
  ];

  return (
    <CustomFilterSelect
      source={source}
      label={label}
      choices={DateFilterData}
      variant={variant}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterDateLastYear;
